import styled from 'styled-components';

export const Container = styled.form`
  h2 {
    color: var(--text-title);
    font-size: 1.5rem;
    // margin-bottom: 1rem;
  }

  h3 {
    color: var(--blue);
    font-size: 1.2rem;
    font-weight: 500;
    // margin-bottom: 1rem;
  }

  p {
    margin-bottom: 1rem;

    span {
      color: var(--blue);
      font-size: 1.3rem;
      font-weight: 600;
    }
  }


  .dropdown {
    width: 100%;

    .dropdown-trigger {
      width: 100%;
    }

    .dropdown-menu {
      min-width: 22rem;

      .dropdown-content {
        padding: 0.3rem;
        border-radius: 0.5rem;
        background-color: #fff;
    
        a.dropdown-item {
          padding: 0.3rem;

          &:hover {
            background-color: #fff !important;
          }
        }
      }
    }
  }

  select {
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  input,
  select {
    width: 100%;
    padding: 0 1.5rem;
    height: 3rem;
    border-radius: 0.25rem;

    border: 1px solid #d7d7d7;
    background: var(--input-background);

    font-weight: 400;
    font-size: 1rem;

    &::placeholder {
      color: var(--text-body);
    }

    & + input,
    & + select {
      margin-top: 1rem;
    }
  }

  button + button {
    margin-top: 1.5rem;
  }

  button[type='submit'] {
    width: 100%;
    padding: 0 1.5rem;
    height: 3rem;
    background: var(--green);
    color: #fff;
    border-radius: 1rem;
    border: 0;
    font-size: 1rem;
    // margin-top: 1.5rem;
    font-weight: 600;

    transition: filter 0.2s;

    &:hover {
      filter: brightness(0.9);
    }
  }

  .secondButton {
    width: 100%;
    padding: 0 1.5rem;
    height: 3rem;
    background: var(--red);
    color: #fff;
    border-radius: 1rem;
    border: 0;
    font-size: 1rem;
    // margin-top: 1.5rem;
    font-weight: 600;

    transition: filter 0.2s;

    &:hover {
      filter: brightness(0.9);
    }
  }
`;

export const Result = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h2 {
    color: var(--text-title);
    font-size: 1.5rem;
    margin-bottom: 2rem;
  }

  img {
    cursor: pointer;
  }
`;
